export const CANVAS_WIDTH = 1262
export const CANVAS_HEIGHT = 610
export const CANVAS_PADDING = 20
export const ROW_SPACE = 80

export const CLIENT_BOX_HEIGHT = 60
export const CLIENT_BOX_WIDTH = 200
export const CLIENT_BOX_Y = CANVAS_PADDING

export const LB_BOX_WIDTH = 300
export const LB_BOX_HEIGHT = 202
export const LB_BOX_Y = CLIENT_BOX_Y + CLIENT_BOX_HEIGHT + 40
export const LB_BOX_X = CANVAS_WIDTH / 2 - LB_BOX_WIDTH / 2

export const DEST_BOX_Y = LB_BOX_Y + LB_BOX_HEIGHT + ROW_SPACE
export const DEST_BOX_WIDTH = 250
export const DEST_BOX_HEIGHT = 120
export const DEST_BOX_GAP = 30
